import { useStore } from 'jotai';
import { type ReactNode, useMemo } from 'react';

import { createSpotlightApi } from './api';
import { SpotlightAPIContext } from './context';

/**
 * Provides the imperative Spotlight API, bound to the ambient jotai store, to
 * everything below it. Mounted once in the app shell so consumers (register
 * hooks) and the host share one API over one store.
 */
export function SpotlightProvider({ children }: { children: ReactNode }) {
  const store = useStore();
  const api = useMemo(() => createSpotlightApi(store), [store]);
  return <SpotlightAPIContext.Provider value={api}>{children}</SpotlightAPIContext.Provider>;
}
